<div class="p-6 flex justify-between">
  <h1 class="font-semibold text-[22px]">
    Crear nuevo pedido
  </h1>
  <span class="text-base cursor-pointer" (click)="close()">
      X
  </span>
</div>
<div class="pl-6 pr-6 pb-6 flex flex-col gap-6">
  <div>
    <p class="text-sm">Elige cómo crear tu pedido</p>
  </div>
  <div class="flex flex-row items-center justify-around">
    <div class="flex flex-col  gap-3">
      <div class="flex justify-center">
        <button (click)="createNewOrder()"
          class="flex flex-col justify-center rounded-2xl items-center bg-orange-500 hover:bg-orange-600 text-white p-4 cursor-pointer">
          <i class="fi-rr-box text-2xl flex"></i>
        </button>
      </div>
      <span class="font-semibold text-sm">
        Desde cero
      </span>
    </div>
    <div class="flex flex-col justify-center gap-3">
      <div class="flex justify-center">
        <button (click)="massiveLoad()"
          class="flex flex-col justify-center rounded-2xl items-center bg-orange-500 hover:bg-orange-600 text-white p-4 cursor-pointer">
          <i class="fi-rs-apps-add text-2xl flex"></i>
        </button>
      </div>
      <span class="font-semibold text-sm">
        Carga masiva
      </span>
    </div>
  </div>
</div>

